import * as calculus from './calculus'
import * as calcExtra from './calc-extra'
import * as frontierExtra from './frontier-extra'
import * as langExtra from './lang-extra'
import * as language from './language'
import * as linearExtra from './linear-extra'
import * as mlExtra from './ml-extra'
import * as nn from './neural-nets'
import * as nnExtra from './nn-extra'
import * as probExtra from './prob-extra'
import * as scaleExtra from './scale-extra'
import * as transformers from './transformers'
import type { ExerciseDef } from './types'
import * as workbench from './your-workbench'

export type LabExample = { id: string; title: string; blurb: string; code: string }

const solution = (ex: ExerciseDef) => ex.solution ?? ex.starter

export const LAB_EXAMPLES: LabExample[] = [
  {
    id: 'scratch',
    title: 'Blank scratchpad',
    blurb: 'Start from nothing. Every stdlib global is available — type a name and a dot to explore.',
    code: `// Your scratchpad. Try typing  vec.  or  plot.  or  new Tensor  and let autocomplete guide you.
console.log("hello from the Lab")
`,
  },
  { id: 'plots', title: 'Plots', blurb: 'Lines, functions and a loss curve.', code: workbench.firstPlot.starter },
  { id: 'descent', title: 'Gradient descent', blurb: 'Roll downhill on a bowl and plot the loss.', code: calculus.descendPlot.starter },
  { id: 'curve-fit', title: 'Fit a thrown ball', blurb: 'Recover gravity from noisy heights with numerical gradients.', code: solution(calcExtra.fitDescend) },
  { id: 'pca', title: 'PCA on handwriting', blurb: '196 pixels squashed to 2 numbers per digit.', code: solution(linearExtra.pcaDigits) },
  { id: 'recommender', title: 'Movie recommender', blurb: 'Taste twins, predictions and an honest error score.', code: solution(linearExtra.recPredict) },
  { id: 'spam', title: 'Naive Bayes spam filter', blurb: 'Word counts and Bayes’ rule, tested on unseen emails.', code: solution(probExtra.nbEvaluate) },
  { id: 'houses', title: 'House prices, start to finish', blurb: 'Baseline, linear model, feature engineering, kNN and an honest test score.', code: solution(mlExtra.houseFinal) },
  { id: 'autograd', title: 'Your autograd engine', blurb: 'The Value class from “Build an autograd engine”, complete.', code: solution(nn.autograd) },
  { id: 'mlp', title: 'Neural net on two moons', blurb: 'An MLP built from Value objects, trained with SGD.', code: solution(nn.trainMlp) },
  { id: 'cnn', title: 'A tiny CNN for digits', blurb: 'Eight learned 3×3 kernels, one matrix multiply.', code: solution(nnExtra.cnnDigits) },
  { id: 'digits', title: 'Read handwriting', blurb: 'An MLP with dropout and best-epoch checkpoints.', code: solution(nnExtra.digitsTrain) },
  { id: 'bigram', title: 'Bigram name generator', blurb: 'Count letter pairs, then dream up names.', code: solution(language.bigram) },
  { id: 'word2vec', title: 'word2vec', blurb: 'Word vectors from scratch with negative sampling.', code: solution(langExtra.sgns) },
  { id: 'nlm', title: 'Neural language model', blurb: 'Embeddings + MLP on names, with Tensor and Adam.', code: solution(language.nlm) },
  { id: 'rnn', title: 'Character RNN', blurb: 'A recurrent network on names, trained through time.', code: solution(langExtra.charRnn) },
  { id: 'gpt', title: 'Tiny GPT', blurb: 'A complete transformer trained on short stories. Swap in your own text!', code: transformers.gptFull.starter },
  { id: 'my-gpt', title: 'Your own GPT, end to end', blurb: 'Tokenizer, warm-up, clipping, validation, top-k sampling, perplexity.', code: solution(scaleExtra.gptGenerate) },
  { id: 'rag', title: 'Search for RAG', blurb: 'TF-IDF retrieval over a small library of documents.', code: solution(frontierExtra.tfidfSearch) },
]
